/** Placeholders shared by the /search input and the Browse input (SEARCH_FILTERS_IN_BROWSE), so they stay in sync. */
export const SEARCH_INPUT_PLACEHOLDERS = {
  prompt: 'Search Keywords or Press Tab for AI Search',
  // STL-1275: lists every link type similarity search accepts.
  similarity: 'Search by keyword, YouTube, Spotify, Apple Music or DISCO URL',
  keyword: 'Search Keywords',
} as const
